import { Contract, ContractData, ContractType } from '@monorepo/types';
import { BaseResponse } from '../core/base-entity-service';
import CrudService from '../core/crud-service';

export default class ContractService extends CrudService {
  static override route = 'contract';

  async signUserContract(params: {
    contractType: ContractType;
    contractData?: ContractData;
  }) {
    try {
      const response = await this.httpService.post<
        { contractType: ContractType },
        BaseResponse<Contract>
      >(this.path, params);

      return response.data;
    } catch (e) {
      console.error('Error signing up contract:', e);
      throw new Error('Failed signing up contract');
    }
  }

  async getUserContracts() {
    try {
      const response = await this.httpService.get<BaseResponse<Contract[]>>(
        this.path,
      );

      return response.data || [];
    } catch (e) {
      console.error('Error fetching user contracts:', e);
      throw new Error('Failed getting contracts');
    }
  }
}
